// @noflow
import './pin-input-group.component.css';

import React, { Children, cloneElement, Component } from 'react';

import { every, take, takeRight } from 'lodash/fp';
import { findDOMNode } from 'react-dom';
import { PinInput } from '~/components/widgets';
import PropTypes from 'prop-types';

export default class PinInputGroup extends Component {
    static propTypes = {
        children: (props, propName, componentName) => {
            if (!every(x => x.type === PinInput, props[propName])) {
                return new Error(
                    `Invalid prop '${propName}' supplied to '${componentName}'.
					Children should be of elements of 'PinInput'.`
                );
            }
        },
        separatorAfterIndex: PropTypes.number,
        separatorChar: PropTypes.string
    };

    handleOnPinDeleted = (pinInput, pinIndex) => {
        if (pinIndex - 1 >= 0) {
            findDOMNode(this[`pinInput${pinIndex - 1}`]).select(); // eslint-disable-line react/no-find-dom-node
        }
    };

    handleOnPinEntered = (pinInput, pinIndex) => {
        if (pinIndex + 1 < Children.count(this.props.children)) {
            findDOMNode(this[`pinInput${pinIndex + 1}`]).focus(); // eslint-disable-line react/no-find-dom-node
        }
    };

    handleOnPinFocused = pinIndex => {
        const node = findDOMNode(this[`pinInput${pinIndex}`]);
        if (node) {
            node.setSelectionRange(0, 1);
        }
    };

    render() {
        const { children, separatorChar = '-', separatorAfterIndex } = this.props;

        // Clone the children so we can capture a `ref` to each one for calling
        // `focus` on later. We can also add some props that a consumer shouldn't
        // be concerned with related to selecting the next `PinInput`
        const autoFocusedChildren = Children.map(children, (child, i) =>
            cloneElement(child, {
                onPinEntered: this.handleOnPinEntered,
                onPinDeleted: this.handleOnPinDeleted,
                onPinFocused: this.handleOnPinFocused,
                pinIndex: i,
                ref: c => (this[`pinInput${i}`] = c)
            })
        );

        let childrenBefore = autoFocusedChildren;
        let childrenAfter;

        const useSeparator =
            separatorAfterIndex !== undefined &&
            separatorAfterIndex >= 0 &&
            separatorAfterIndex < Children.count(autoFocusedChildren);

        if (useSeparator) {
            childrenBefore = take(separatorAfterIndex + 1, autoFocusedChildren);
            childrenAfter = takeRight(separatorAfterIndex + 1, autoFocusedChildren);
        }

        return (
            <ul className="pin-input-group">
                {childrenBefore}
                {useSeparator && <span className="pin-input-group__separator">{separatorChar}</span>}
                {childrenAfter}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/pin-input-group/pin-input-group.component.js